export const PSYCHOLOGICAL_HELP_ATTACHMENT_FORMATS =
    '.doc, .docx, .htm, .html, .odt, .pdf, .xls, .xlsx, .ods, .txt, .png, .jpg, .jpeg';
export const QUALIFICATION_BASIS_ATTACHMENT_FORMATS =
    '.doc, .docx, .htm, .html, .odt, .pdf, .xls, .xlsx, .ods, .txt, .png, .jpg, .jpeg';
export const CHILD_ATTACHMENT_FORMATS = '.png, .jpg, .jpeg';
export const MENU_ATTACHMENT_FORMATS = '.pdf, .png, .jpg, .jpeg';
export const MESSAGE_ATTACHMENT_FORMATS =
    '.doc, .docx, .htm, .html, .odt, .pdf, .xls, .xlsx, .ods, .txt, .png, .jpg, .jpeg, .zip, .ppt, .pptx';
